import { addParametersToURL, isEmpty } from '@utilities';

/**
 * Performs a REST call
 * 
 * @param {Object} options        The options
 * @param {String} options.url    The URL
 * @param {String} options.nonce  The WordPress nonce
 * @param {String} options.method The request method
 * @param {Object} options.data   The body
 * @returns {Promise}
 */
const wpRestCall = async ( { url = '', nonce = '', method = 'GET', data = {}, keepalive = true } ) => {
    // Check if the URL is defined
    if ( isEmpty( url ) ) {
        throw new Error( `Define a valid URL` );
    }

    // Check if the nonce is defined
    if ( isEmpty( nonce ) ) {
        throw new Error( `Define a valid nonce` );
    }

    return await 
        fetch( 
            new Request( 
                addParametersToURL( url, data ), 
                {
                    method: method,
                    headers: new Headers({
                        'X-WP-Nonce': nonce,
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Cache-Control': 'no-cache'
                    }),
                    keepalive: keepalive
                }
            )
        )
        .then( response => response.json() )
}

export default wpRestCall;
